export default __webpack_public_path__ + "6661712e99d1f44c5696d0634026a4b7.woff";